
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Safely fire a Meta Pixel PageView.
 * Retries up to maxRetries times every interval ms if fbq isn't ready yet.
 */
const trackPageView = (retries = 0, maxRetries = 10, interval = 300) => {
  if (typeof (window as any).fbq === 'function') {
    (window as any).fbq('track', 'PageView');
    console.log('[MetaPixel] PageView fired ✅', window.location.pathname);
  } else if (retries < maxRetries) {
    setTimeout(() => trackPageView(retries + 1, maxRetries, interval), interval);
  } else {
    console.warn('[MetaPixel] fbq not available after retries ⚠️');
  }
};

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  // Fire PageView on initial app mount (fbq déjà init dans index.html)
  useEffect(() => {
    trackPageView();
  }, []);

  // Fire PageView on every SPA route change (skip first render, handled above)
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    window.scrollTo(0, 0);
    trackPageView();
  }, [pathname]);

  return null;
};
